module.exports = __webpack_public_path__ + "pc/img/all_icon.16aac90a.png";